'use strict';

/**
* @private
* @function
* @description Toggles class "focus" on focus/blur for container
*/
function initializeEvents() {
	$('#q').focus(function () {
		$(this).parents('.header-search').addClass('focus');
		$(this).data('placeholder', $(this).prop('placeholder'));
		$(this).prop('placeholder', '');
	})
	.blur(function () {
		$(this).parents('.header-search').removeClass('focus');
		$(this).prop('placeholder', $(this).data('placeholder'));
	});
}

exports.init = initializeEvents;
